export const DOC_FLOW_MAPPING_WIDGET_INCLUDE_ARCHIVED_FIELD_QA_NAME =
  'docFlowMappingWidgetIncludeArchived'
